export const BASE_URL = 'https://ugs-backend' + process.env.REACT_APP_URL_SUFFIX;
export const LOBBY_WS_BASE_URL = "wss://ugs-backend" + process.env.REACT_APP_URL_SUFFIX + "ws/lobby/";
export const CHAT_WS_BASE_URL = "wss://ugs-backend" + process.env.REACT_APP_URL_SUFFIX + "ws/chat/";